import { useEffect, useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
// import LogoutContainer from "../../Layout/LogoutContainer";
import { HeaderStyle } from "../../Common/styles/header";
import UsersList from "./UsersList";
import { useAppSelector } from "../../../Redux/hooks";
import { platformAdminPermissions } from "../../../utils/roles";
import PermissionMatrix from "./PermissionMatrix";
import { dataTablePageShell } from "../../../utils/dataTableShell";

const Users = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get("query") ?? "");
  const [showModal, setShowModal] = useState(false);
  const [showPermissionMatrix, setShowPermissionMatrix] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.manageUser),
    [platformPermissions]
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (searchText) {
      params.set("query", searchText);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, searchText]);

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Users
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => setShowPermissionMatrix(true)}
            >
              Platform Rights
            </Button>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New User
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ ...dataTablePageShell("calc(100% - 72px)"), p: 2.5 }}>
        <UsersList
          searchText={searchText}
          showModal={showModal}
          setShowModal={setShowModal}
          setSearchText={setSearchText}
          canEdit={canEdit}
        />
      </Box>
      {showPermissionMatrix && (
        <PermissionMatrix
          open={showPermissionMatrix}
          onClose={() => setShowPermissionMatrix(false)}
        />
      )}
    </>
  );
};

export default Users;
